module.exports = {
	"id": "VG",
	"name": "British Virgin Islands",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.013554,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.020331,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.006777,
			"27": 0.020331,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.027108,
			"32": 0.033885,
			"33": 0.06777,
			"34": 0.020331,
			"35": null,
			"36": 0.060993,
			"37": 0.027108,
			"38": 0.013554,
			"39": 0.027108,
			"40": null,
			"41": 0.060993,
			"42": 0.027108,
			"43": 0.311742,
			"44": 0.013554,
			"45": 0.006777,
			"46": 0.020331,
			"47": 0.081324,
			"48": 0.108432,
			"49": 2.405835,
			"50": 0.074547,
			"51": 0.582822,
			"52": 0.718362,
			"53": 28.226205,
			"54": 5.496147,
			"55": 0.020331,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.033885,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.020331,
			"22": null,
			"23": null,
			"24": 0.013554,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.054216,
			"29": 0.047439,
			"30": 0.047439,
			"31": 0.047439,
			"32": 0.115209,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.013554,
			"38": 0.020331,
			"39": null,
			"40": 0.013554,
			"41": 0.006777,
			"42": 0.013554,
			"43": 0.020331,
			"44": null,
			"45": 0.033885,
			"46": 0.033885,
			"47": 0.216864,
			"48": 0.399843,
			"49": 3.402054,
			"50": 0.162648,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.006777
		},
		"opera": {
			"9": null,
			"11": 0.013554,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.155871,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.027108,
			"37": 0.277857,
			"38": 0.013554,
			"39": 0.040662,
			"40": 0.33885,
			"41": 0.06777,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.033885,
			"5": 0.006777,
			"6": null,
			"7": 0.033885,
			"8": 0.189756,
			"9": 0.433728,
			"10": 2.602368,
			"3.1": null,
			"3.2": null,
			"5.1": 0.121986,
			"6.1": 0.13554,
			"7.1": 0.006777,
			"9.1": 1.396062
		},
		"ios_saf": {
			"8": 0,
			"10": 8.00654922731,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.215767237094,
			"8.1-8.4": 0.398620827852,
			"9.0-9.2": 0.190167734388,
			"9.3": 2.90127697336
		},
		"android": {
			"3": 0,
			"4": 0.0318885452196,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00398606815245,
			"4.1": 0.115026538114,
			"4.2-4.3": 0.287566345284,
			"4.4": 0.659409560078,
			"4.4.3-4.4.4": 0.665103943152
		},
		"ie": {
			"6": 0.0210823630435,
			"7": 0.196768721739,
			"8": 0.983843608696,
			"9": 0.632470891304,
			"10": 0.365427626087,
			"11": 7.49126633478,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00955746404031,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000265485112231
		},
		"edge": {
			"12": 0.393066,
			"13": 1.240191,
			"14": 2.466828
		},
		"ie_mob": {
			"10": 0.0565613802817,
			"11": 0.230285619718
		},
		"bb": {
			"7": 0.035453,
			"10": null
		},
		"samsung": {
			"0": 4.257583
		},
		"and_uc": {
			"0": 0.093467
		},
		"op_mini": {
			"0": 0.128766050847
		},
		"and_chr": {
			"0": 17.363776
		},
		"and_ff": {
			"0": 0.019338
		}
	},
	"total": 98.5742795457
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/VG.json
 ** module id = 678
 ** module chunks = 0
 **/